/**
 * Horizontal carousel for Compatible machines section.
 * Shows prev/next controls only when the track overflows.
 */
if (!customElements.get('compatible-machines-carousel')) {
  customElements.define(
    'compatible-machines-carousel',
    class CompatibleMachinesCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-compat-track]');
        this.prevBtn = this.querySelector('[data-compat-prev]');
        this.nextBtn = this.querySelector('[data-compat-next]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-compat-item]'));
        this.scrollRaf = null;
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnResize = this.syncNav.bind(this);
      }

      connectedCallback() {
        if (!this.track || !this.items.length) return;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.go(-1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.go(1));
        }

        this.track.addEventListener('scroll', this.boundOnScroll, { passive: true });
        window.addEventListener('resize', this.boundOnResize);

        this.syncNav();
      }

      disconnectedCallback() {
        if (this.track) {
          this.track.removeEventListener('scroll', this.boundOnScroll);
        }
        window.removeEventListener('resize', this.boundOnResize);
        if (this.scrollRaf) {
          window.cancelAnimationFrame(this.scrollRaf);
          this.scrollRaf = null;
        }
      }

      onScroll() {
        if (this.scrollRaf) return;
        this.scrollRaf = window.requestAnimationFrame(() => {
          this.scrollRaf = null;
          this.syncNav();
        });
      }

      itemStep() {
        if (!this.items.length || !this.track) return 0;
        var first = this.items[0];
        var style = window.getComputedStyle(this.track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      canScroll() {
        if (!this.track) return false;
        return this.track.scrollWidth > this.track.clientWidth + 2;
      }

      syncNav() {
        var overflow = this.canScroll();
        if (this.prevBtn) this.prevBtn.hidden = !overflow;
        if (this.nextBtn) this.nextBtn.hidden = !overflow;
        if (!overflow || !this.track) return;

        var maxScroll = this.track.scrollWidth - this.track.clientWidth;
        var left = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = left <= 2;
        if (this.nextBtn) this.nextBtn.disabled = left >= maxScroll - 2;
      }

      go(direction) {
        if (!this.track) return;
        var step = this.itemStep();
        if (!step) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: step * direction,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    }
  );
}
